"use client";

import { useSyncExternalStore } from "react";

function getServerSnapshot(): boolean {
  return true;
}

function getSnapshot(): boolean {
  return navigator.onLine;
}

function subscribe(callback: () => void): () => void {
  window.addEventListener("online", callback);
  window.addEventListener("offline", callback);
  return () => {
    window.removeEventListener("online", callback);
    window.removeEventListener("offline", callback);
  };
}

/**
 * Tracks the browser's connectivity status. Returns true when online.
 */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
